import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

/**
 * Labelled horizontal bars (design item 27) — replaces the dashboard donuts, whose
 * legends cut labels off ("An…", "Un…"). Each row: label, "count · %", bar.
 * A row with a link opens the matching filtered list.
 */
export default function LabelledBars({ segments, colors = {}, defaultColor = "#3B2A9F", linkFor, emptyText = "No data yet" }) {
  const rows = [...(segments || [])].sort((a, b) => (b.value || 0) - (a.value || 0));
  const total = rows.reduce((sum, s) => sum + (s.value || 0), 0);

  if (!rows.length || total === 0) {
    return <Typography sx={{ fontSize: 13, color: "#6B7280", py: 2 }}>{emptyText}</Typography>;
  }

  return (
    <Stack spacing={1.25} sx={{ width: "100%", py: 0.5 }}>
      <Typography sx={{ fontSize: 13, color: "#6B7280" }}>
        <Box component="span" sx={{ fontWeight: 700, color: "#111827", fontSize: 18, mr: 0.75 }}>
          {total.toLocaleString("en-GB")}
        </Box>
        in total
      </Typography>
      {rows.map((s) => {
        const pct = Math.round(((s.value || 0) / total) * 100);
        const href = linkFor ? linkFor(s.label) : null;
        const row = (
          <Box>
            <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#1F2937" }}>{s.label}</Typography>
              <Typography sx={{ fontSize: 13, color: "#374151", fontVariantNumeric: "tabular-nums" }}>
                {(s.value || 0).toLocaleString("en-GB")} · {pct}%
              </Typography>
            </Stack>
            <Box sx={{ height: 8, borderRadius: 4, background: "#F3F4F6", overflow: "hidden" }}>
              <Box sx={{ height: "100%", width: `${pct}%`, borderRadius: 4, background: colors[s.label] || defaultColor }} />
            </Box>
          </Box>
        );
        return href ? (
          <Box
            key={s.label}
            component={Link}
            to={href}
            sx={{ textDecoration: "none", color: "inherit", borderRadius: 1, p: 0.5, m: -0.5, "&:hover": { background: "#F9FAFB" } }}
          >
            {row}
          </Box>
        ) : (
          <Box key={s.label}>{row}</Box>
        );
      })}
    </Stack>
  );
}
